$(function() {
    $(".webservice_results").tablesorter();
});